module.exports = __webpack_public_path__ + "assets/icons/ic_filter_24px.svg";